var render = function render(){
  var _vm$order$seller$user;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.order ? _c('div', [_c('div', {
    staticClass: "elevation-1 rounded pa-5 white",
    class: _vm.inquiry.status == 0 ? 'greeny--border' : 'primary--border'
  }, [_c('v-row', {
    staticClass: "align-center"
  }, [_c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('h3', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Status : ")]), _vm._v(" " + _vm._s(_vm.getStatusText(_vm.lastEvent(_vm.inquiry.events[0]).code)) + " ")]), _c('div', {
    staticClass: "text-caption mt-1 font-weight-bold"
  }, [_vm._v(" Inquiry Created "), _c('code', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm._f("getOnlyDate")(_vm.inquiry.created)) + " " + _vm._s(_vm._f("getOnlyTime")(_vm.inquiry.created)))]), _vm._v(" (GMT+" + _vm._s(_vm.getGmtDiff) + ") by "), _c('code', {
    staticClass: "text-caption greeny white--text"
  }, [_vm._v(_vm._s(_vm.origin))])])]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-end"
  }, [_c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v(" " + _vm._s(_vm.order.id) + " ")]), _c('OrderIconsField', {
    attrs: {
      "order": _vm.order,
      "showPrintableInfo": true,
      "showDistributedInfo": true,
      "showGroupOrderInfo": true,
      "showClaimInfo": false,
      "showArchiveOrder": true
    }
  }), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "",
      "color": "accent"
    },
    on: {
      "click": function ($event) {
        return _vm.navOrder(_vm.order.id);
      }
    }
  }, [_vm._v("Order Detail ")])], 1), _c('div', {
    staticClass: "caption secondary--text mt-1 font-weight-bold"
  }, [_vm._v(" Order Created "), _c('code', {
    staticClass: "text-caption"
  }, [_vm._v(_vm._s(_vm._f("getOnlyDate")(_vm.order.created)) + " " + _vm._s(_vm._f("getOnlyTime")(_vm.order.created)))]), _vm._v(" (GMT+" + _vm._s(_vm.getGmtDiff) + ") by "), _c('code', {
    staticClass: "text-caption greeny white--text"
  }, [_vm._v(" " + _vm._s((_vm$order$seller$user = _vm.order.seller.user.fullName) !== null && _vm$order$seller$user !== void 0 ? _vm$order$seller$user : _vm.order.seller.user.name))])])])], 1)], 1), _c('external-booking-summary', {
    attrs: {
      "bookings": _vm.order.bookings,
      "tenant-name": _vm.order.seller.tenant.name
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }